
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState, useRef, useCallback } from "react";
import AkkhorLayout from "../layout/akkhor";
import AlertErrorForm from "../component/AlertErrorForm";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { confirmAlert } from "react-confirm-alert";
import Cropper from "react-easy-crop";
import men_teacher from "../assets/img/thumbnail-icon.png"
import getCroppedImg from "../component/getCroppedImg";
import Spinner from "../component/Spinner";
import { Editor } from '@tinymce/tinymce-react';
import { Modal } from "react-bootstrap";
import SRList from "../component/List";


export default function FormBaiGiang() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [detail, setDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);
    const fileInputRef = useRef(null);
    const editorRef = useRef(null);
    const editorPageRef = useRef(null);
    
    const [imageSrc, setImageSrc] = useState(null); // ảnh gốc chọn từ input
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [showCropper, setShowCropper] = useState(false);
    const [nameFile, setNameFile] = useState(null);
    const [avatar, setAvatar] = useState(null);
    const [loadingImage, setLoadingImage] = useState(false)
    const [editorMounted, setEditorMounted] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);
    const [listPage, setListPage] = useState([]);
    const [pageContent, setPageContent] = useState('');
    const [pageTitle, setPageTitle] = useState('');


    useEffect(() => {
        setEditorMounted(true); // chạy 1 lần khi mount
    }, []);

    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "learninghub_baigiang/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                setDetail(res.data.data);
                                setAvatar(res.data.data.thumbnail)
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id]
    );
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "learninghub_baigiang_pages?baigiang_id=" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                setListPage(res.data.data);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, loadingPage]
    );

    const formik = useFormik({
        initialValues: detail ? detail : { title: '', type_id: null, description: '', user_id: null, qr_result: '' },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Vui lòng nhập tiêu đề'),
            type_id: Yup.string().trim().nullable().required('Vui lòng chọn khóa học'),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setTimeout(() => {
                if (avatar) {
                    values.thumbnail = avatar
                }
                values.description = editorRef.current?.getContent();
                setLoading(true)
                if (id > 0) {
                    Axios.put(URL_LIST_ALL + 'learninghub_baigiang/' + id, values, user.config).then(res => {
                        setSubmitting(false);
                        setLoading(false)
                        if (res.data.status === "success") {
                            window.location.reload()
                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                } else {
                    // console.log(values);
                    Axios.post(URL_LIST_ALL + 'learninghub_baigiang', values, user.config).then(res => {
                        setSubmitting(false);
                        setLoading(false)
                        if (res.data.status === "success") {
                            window.location.href = '/edit-learninghub_baigiang/' + res.data.id

                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                }
            }, 200);
            setSubmitting(false)
        },
    });

    // Hàm này lưu vùng crop tính theo pixel
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    // Khi người dùng chọn file từ input
    const onFileChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const imageDataUrl = await readFile(file);
            setNameFile(file.name);
            setImageSrc(imageDataUrl);
            setShowCropper(true);
        }
    };

    // Hàm đọc file thành base64 để hiển thị cropper
    function readFile(file) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.addEventListener("load", () => resolve(reader.result));
            reader.readAsDataURL(file);
        });
    }

    // Hàm crop và upload ảnh
    const onCropConfirm = async () => {
        try {
            const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
            const resizedBlob = croppedImageBlob; // hoặc resize tiếp nếu muốn

            let data = new FormData();
            data.append("type", "s3");
            data.append("name", "file");
            data.append("file", resizedBlob, nameFile); // đổi tên nếu muốn
            data.append("filetype", resizedBlob.type);

            setLoadingImage(true);
            Axios.post(URL_LIST_ALL + "fileupload", data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: user.config.headers.Authorization,
                },
            })
                .then((res) => {
                    if (res.data.status === "success") {
                        const url = res.data.message;
                        if (url) {
                            setAvatar(url);
                            setLoadingImage(false);
                            setShowCropper(false);
                            setImageSrc(null);
                        }
                    } else {
                        setLoadingImage(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setLoadingImage(false);
                });
        } catch (e) {
            console.error(e);
        }
    };

    const convertYouTubeLinksToIframes = (html) => {
        return html.replace(
            /(?:<p>)?(https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+))(?:<\/p>)?/g,
            (_, __, videoId) => `
            <div class="youtube-embed">
              <iframe 
                src="https://www.youtube.com/embed/${videoId}"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>`
        );
    };
    const handleBlur = () => {
        const content = editorRef.current.getContent();
        const transformed = convertYouTubeLinksToIframes(content);
        if (content !== transformed) {
            editorRef.current.setContent(transformed);
        }
    };

    const onSavePage = () => {
        if (!pageTitle || pageTitle == '') {
            alert("Vui lòng nhập tiêu đề")
            return false
        }
        let content = editorPageRef.current?.getContent();
        if (!content || content == '') {
            alert("Vui lòng nhập nội dung")
            return false
        }
        setLoading(true)
        let position = 1
        if (listPage && listPage.length > 0) {
            position = listPage.length + 1
        }
        Axios.post(URL_LIST_ALL + 'learninghub_baigiang_pages', { baigiang_id: id, title: pageTitle, page_content: content, status: 1, position: position }, user.config).then(res => {
            setLoading(false)
            if (res.data.status === "success") {
                window.location.href = '/edit-learninghub_baigiang/' + id
            } else {
                confirmAlert({
                    title: 'Lỗi',
                    message: res.data.message,
                    buttons: [{ label: 'OK' }]
                });
            }
        }).catch(err => console.log(err));
    };

    let columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        { name: "title", label: "Tiêu đề" },
        { name: "author_name", label: "Người tạo" },
        { name: "position", label: "Vị trí" },
        { name: "datecreate", label: "Ngày tạo" }
    ];

    const handleUploadImage = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        try {
            const resizedBlob = await convertImageToBlobAfterResize(file);
            const formData = new FormData();
            formData.append('file', resizedBlob, file.name); // giữ tên gốc
            formData.append('changename', 1);
            formData.append('folder', 0);

            const res = await Axios.post(URL_LIST_ALL + 'fileupload', formData, user.config);
            if (res.data.status === 'success') {
                const imgURL = res.data.message;
                const imgTag = `<img src="${imgURL}" alt="uploaded image" />`;
                if (editorPageRef.current) {
                    editorPageRef.current.insertContent(imgTag);
                }
            } else {
                alert("Upload thất bại: " + res.data.message);
            }
        } catch (err) {
            console.error("Lỗi upload ảnh:", err);
            alert("Lỗi upload ảnh");
        }
    };

    const convertImageToBlobAfterResize = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const img = new Image();
                img.src = reader.result;
                img.onload = () => {
                    const maxSize = 2048;
                    const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    // Chuyển base64 sang blob
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                resolve(blob);
                            } else {
                                reject(new Error("Không thể tạo blob từ canvas"));
                            }
                        },
                        "image/jpeg",
                        1
                    );
                };
                img.onerror = reject;
            };
            reader.onerror = reject;
        });
    };

    return (
        <AkkhorLayout idrole="learning_profile_manager">
            <div className="card height-auto mt-5">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Tạo Bài giảng</h3>
                        </div>
                    </div>
                    <form className="new-added-form  form-info" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 col-sm-6 form-group">
                                <label>Tiêu đề <span className="text-danger">*</span></label>
                                <input type="text" placeholder="VD: Bài học đầu tiên" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Thuộc khóa học <span className="text-danger">*</span></label>
                                <select className="form-select height32" {...formik.getFieldProps("type_id")}>
                                    <option value="" >Chọn khóa học</option>
                                    <option value="1" >Khóa học kỹ năng</option>
                                    <option value="2" >Khóa học dự án</option>
                                </select>
                                <AlertErrorForm formik={formik} name="type_id"></AlertErrorForm>
                            </div>
                            <div className="col-12"></div>
                            <div className="col-12 col-sm-4 info-table table-responsive">
                                <h5>Ảnh đại diện:</h5>
                                <div className="avatar-group mt-3">
                                    <button type="button" className="btn p-0 btn-avatar" onClick={() => inputRef.current.click()}>
                                        {loadingImage ? (
                                            "Đang tải..."
                                        ) : avatar ? (
                                            <img src={avatar} alt="" className="avatar" />
                                        ) : (
                                            <img
                                                src={(men_teacher)}
                                                alt=""
                                                className="avatar"
                                            />
                                        )}
                                        <span className="fas fa-upload upload-icon"></span>
                                    </button>
                                    <input
                                        type="file"
                                        id="file"
                                        ref={inputRef}
                                        style={{ display: "none" }}
                                        accept="image/*"
                                        onChange={onFileChange}
                                    />

                                    {showCropper && (
                                        <>
                                            <div className="cropper-modal">
                                                <Cropper
                                                    image={imageSrc}
                                                    crop={crop}
                                                    zoom={zoom}
                                                    aspect={1}
                                                    onCropChange={setCrop}
                                                    onZoomChange={setZoom}
                                                    onCropComplete={onCropComplete}
                                                />

                                            </div>

                                        </>
                                    )}
                                </div>
                                {showCropper && <div className="w-100 mt-2">
                                    <button type="button" className="btn btn-sm btn-info" onClick={onCropConfirm}>Lưu</button>
                                    <button type="button" className="btn btn-sm btn-danger ml-2" onClick={() => {
                                        setShowCropper(false);
                                        setImageSrc(null);
                                    }}
                                    >
                                        Hủy
                                    </button>
                                </div>}
                            </div>
                            <div className="col-12 col-sm-8 form-group mt-2">
                                <label>Mô tả</label>
                                {editorMounted && (
                                    <Editor
                                        apiKey="8vzg9hkuturhxampptav8epspf6gw56ny951lc2o70rehku4"
                                        onInit={(_, editor) => (editorRef.current = editor)}
                                        onBlur={handleBlur}
                                        initialValue={formik.values['description']}
                                        init={{
                                            height: 300,
                                            menubar: false,
                                            plugins: ['advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen', 'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount', 'emoticons'],
                                            toolbar: 'undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | emoticons charmap | code | link | help',
                                            placeholder: 'Nhập nội dung mô tả...',
                                        }}
                                    />
                                )}
                            </div>
                            {detail &&
                                <div className="w-100 mt-2">
                                    <div className="w-100 ">
                                        <button className="btn btn-sm btn-info" onClick={() => setShowModal(true)} type="button">Thêm trang</button>
                                    </div>

                                </div>
                            }
                            <div className="col-12"></div>
                            {(id > 0 && listPage && listPage.length > 0) &&
                                <div className="w-100 mt-3">
                                    <h3>Danh sách trang</h3>
                                    <SRList name="learninghub_baigiang_pages" noAction={true} linkaction="learninghub_baigiang_pages" idrole="learninghub_baigiang" params={"orderby=position-asc&baigiang_id=" + id} defaultLimit={50} serverSide={true} columns={columns} ></SRList>
                                </div>
                            }
                            <div className="col-12 form-group mt-5">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>

                        </div>
                    </form>

                </div>
            </div>

            <Modal
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                }}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <div className="w-100 d-flex justify-content-between align-items-center">
                            <h5 className="modal-title">Thêm trang</h5>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 form-group">
                            <label>Tiêu đề <span className="text-danger">*</span></label>
                            <input type="text" placeholder="VD: Bài học đầu tiên" className="form-control height32" value={pageTitle} onChange={(e) => setPageTitle(e.target.value)} autoComplete="off" />
                        </div>
                        <div className="col-12 mt-2 ">
                            <label>Nội dung</label>
                            <div className="modal-body-post">
                                {editorMounted && (
                                    <Editor
                                        apiKey="8vzg9hkuturhxampptav8epspf6gw56ny951lc2o70rehku4"
                                        onInit={(_, editor) => (editorPageRef.current = editor)}
                                        onBlur={() => {
                                            const content = editorPageRef.current.getContent();
                                            const transformed = convertYouTubeLinksToIframes(content);
                                            if (content !== transformed) {
                                                editorPageRef.current.setContent(transformed);
                                            }
                                        }}
                                        initialValue={pageContent}
                                        init={{
                                            height: 300,
                                            menubar: false,
                                            plugins: ['advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen', 'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount', 'emoticons'],
                                            toolbar: 'undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | emoticons charmap | code | link | help',
                                            placeholder: 'Nhập nội dung...',
                                        }}
                                    />
                                )}
                                <div className="upload-image-post">
                                    <button className="btn btn-outline-info" type="button" onClick={() => fileInputRef.current.click()}>
                                        <i className='fas fa-camera-retro'></i>
                                    </button>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        onChange={handleUploadImage}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 form-group mt-5">
                            <button type="button" onClick={() => onSavePage()} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </AkkhorLayout>
    );
}
